module.exports = __webpack_public_path__ + "static/media/user.5b3b0f2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/user.svg
// module id = 503
// module chunks = 0